import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconClose from '@material-ui/icons/Close';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconSearch } from 'src/assets/icons/Search';
import CustomTextField from 'src/components/CustomTextField';

import useStyles from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  value: PropTypes.string,
  disabled: PropTypes.bool,
  bluish: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  onEnterPress: PropTypes.func,
  hideIcon: PropTypes.bool,
  inputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  autoFocus: PropTypes.bool,
  onFocus: PropTypes.func,
};

const defaultProps = {
  className: null,
  classes: null,
  disabled: false,
  bluish: false,
  value: '',
  placeholder: '',
  onEnterPress: () => {},
  hideIcon: false,
  inputRef: null,
  autoFocus: false,
  onFocus: null,
};

const SearchField = ({
  className,
  classes,
  value,
  onChange,
  disabled,
  placeholder,
  bluish,
  onEnterPress,
  hideIcon,
  inputRef,
  autoFocus,
  onFocus,
}) => {
  const styles = useStyles({ classes });

  const handleNativeChange = React.useCallback(
    (event) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  const handleClear = React.useCallback(() => {
    onChange('');
  }, [onChange]);

  return (
    <CustomTextField
      className={cx(styles.root, className, {
        [styles.bluish]: bluish,
      })}
      value={value}
      onChange={handleNativeChange}
      onKeyPress={(event) => {
        if (event.key === 'Enter') {
          onEnterPress();
        }
      }}
      variant="outlined"
      placeholder={placeholder || 'Search'}
      disabled={disabled}
      InputProps={{
        classes: {
          root: styles.input,
          notchedOutline: styles.outline,
        },
        startAdornment: !hideIcon && (
          <InputAdornment position="start">
            <IconSearch className={styles.iconSearch} />
          </InputAdornment>
        ),
        endAdornment: !hideIcon && value && (
          <InputAdornment position="end">
            <IconButton
              onClick={handleClear}
              disabled={disabled}
              aria-label="Clear"
            >
              <IconClose className={styles.iconClear} />
            </IconButton>
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: true,
      }}
      inputRef={inputRef}
      aria-label="SearchField"
      data-testid="searchField"
      autoFocus={autoFocus}
      onFocus={onFocus}
    />
  );
};

SearchField.propTypes = propTypes;
SearchField.defaultProps = defaultProps;

export default SearchField;
